import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '电影分类', to: '/category/movie' },
  { label: '电视剧分类', to: '/category/tv' },
  { label: '综艺分类', to: '/category/variety' },
  { label: '搜索作品', to: '/search' },
];

const aboutLinks = [
  { label: '关于我们', to: '/about' },
  { label: '联系我们', to: '/contact' },
];

export default function SiteFooter() {
  return (
    <footer className="mt-20 border-t border-primary-800/40 bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-14 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className="ri-movie-2-line text-xl" aria-hidden="true" />
            </span>
            <span className="font-heading text-lg font-bold text-background-50">长日光阴</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            长日光阴是聚焦多元影视作品推荐与剧情介绍的分享平台，覆盖电影、电视剧与综艺，帮助观众查找作品、了解剧情、发现优质影片。
          </p>
          <div className="mt-5 flex items-center gap-3">
            {[
              { icon: 'ri-wechat-line', label: '微信' },
              { icon: 'ri-weibo-line', label: '微博' },
              { icon: 'ri-bilibili-line', label: '哔哩哔哩' },
              { icon: 'ri-mail-line', label: '邮箱' },
            ].map((item) => (
              <span
                key={item.label}
                aria-label={item.label}
                className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-200 transition-colors hover:bg-accent-500 hover:text-primary-950"
              >
                <i className={`${item.icon} text-lg`} aria-hidden="true" />
              </span>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
            <Link to="/category/movie" className="transition-colors hover:text-accent-400">
              浏览分类
            </Link>
          </h4>
          <ul className="mt-4 space-y-3">
            {quickLinks.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="text-sm text-background-300 transition-colors hover:text-accent-400">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
            <Link to="/about" className="transition-colors hover:text-accent-400">
              关于本站
            </Link>
          </h4>
          <ul className="mt-4 space-y-3">
            {aboutLinks.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="text-sm text-background-300 transition-colors hover:text-accent-400">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800/40">
        <div className="mx-auto flex w-full flex-col gap-2 px-4 py-5 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 长日光阴 · 本站为影视内容介绍演示站点，内容均为虚构示例。</p>
          <p>本站不提供任何在线播放、下载及支付功能。</p>
        </div>
      </div>
    </footer>
  );
}